import { handleActions } from 'redux-actions'

import c from 'constants/notification-constants'

import type { Notification } from '../models/notification-model'

// Plain array of active toasts (was an Immutable OrderedMap keyed by id).
export default handleActions<Notification[], any>(
  {
    [c.ADD]: (s, a) => [...s, { id: a.payload.id, message: a.payload.message, type: a.payload.type }],

    [c.REMOVE]: (s, a) => s.filter(n => n.id !== a.payload),
  },
  [],
)
